// extracted by mini-css-extract-plugin
export default {"container":"Medium_container__nH7Rf","row":"Medium_row__JCRst","packageCard":"Medium_packageCard__Yo+Ov","text":"Medium_text__4uVq4"};